<template>
    <div class="center_statement_box">
        <!-- 标题 -->
        <center-title>{{$t("message.cmonth.title")}}</center-title>
        <!-- 内容 -->
        <div class="center_statement_content">
            <!-- 日期选择区域 -->
            <div class="center_statement_date">
                <span>{{$t("message.cmonth.search")}}</span>
                <el-date-picker
                    v-model="startDate"
                    type="month"
                    size="small"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    @change="startChange"
                    :placeholder="$t('message.cmonth.place1')">
                </el-date-picker>
                <span>&nbsp;-&nbsp;</span>
                <el-date-picker
                    v-model="endDate"
                    type="month"
                    size="small"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    :picker-options="pickerOptions"
                    :placeholder="$t('message.cmonth.place2')">
                </el-date-picker>
                <!-- 查询按钮 -->
                <el-button 
                    size="mini" 
                    type="primary"
                    @click="getData(sortAttr, sortMode)"
                    class="center_statement_search">
                    <span>{{$t("public.searchBtn")}}</span>
                </el-button>
            </div>
            <!-- 表格 -->
            <el-table
                :data="statement"
                :default-sort="{prop: '', order: ''}"
                @sort-change="handleSort"
				 @selection-change="handleSelect">
				<!-- 多选框 -->
				<el-table-column
				    type="selection"
				    :reserve-selection="true"
				    align="center"
				    width="55">
				</el-table-column>
                <!-- 月结单号 -->
                <el-table-column
                    prop="month_no"
                    sortable="custom"
                    :label="$t('message.cmonth.table6')">
                </el-table-column>
                <!-- 月份列 -->
                <el-table-column
                    prop="month"
                    sortable="custom"
                    :label="$t('message.cmonth.table1')">
                </el-table-column>
                <!-- 上传日期列 -->
                <el-table-column
                    prop="createtime"
                    sortable="custom"
                    :label="$t('message.cmonth.table2')">
                    <template v-slot="{row}">
                        <span>{{row.createtime}}</span>
                    </template>
                </el-table-column>
                <!-- 下载列 -->
                <el-table-column
                    :label="$t('message.cmonth.table3')"
                    align="center">
                    <template 
                        v-slot="{row}">
                        <div 
                            v-for="(item, index) in row.files"
                            :key="index"
                            class="center_statement_download_box">
                            <a :href="item.file" target="view_window" style="">{{item.name}}</a>
                        </div>
                    </template>
                </el-table-column>
				<!-- 下載(PDF) -->
                <el-table-column
                    :label="$t('message.cmonth.table5')"
                    align="center">
                    <template v-slot="{row}">
                        <a :href="$URL.baseUrl+'index/tcpdf/month?lang=cn&month='+row.month" target="view_window">{{$t("message.cmonth.downloadBtn")}}</a>
                    </template>
                </el-table-column>
				<!-- 下載(Excel) -->
                <el-table-column
                    :label="$t('message.cmonth.table4')"
                    align="center">
                    <template v-slot="{row}">
                        <a :href="$URL.baseUrl+'index/month/excel?lang=cn&month='+row.month" target="view_window">{{$t("message.cmonth.downloadBtn")}}</a>
                    </template>
                </el-table-column>
            </el-table>
            <table-pagination
                :current-page="page.current_page"
                :page-count="page.last_page"
                @current-change="handleCurrent">
            </table-pagination>
			<!-- 多選下載 -->
			<el-button
			    type="primary"
			    @click="submitCart"
			    class="shopping_cart_table_btn">
			    <span>下載(PDF)</span>
			</el-button>
			<el-button
			    type="primary"
			    @click="submitCartr"
			    class="shopping_cart_table_btn">
			    <span>下載(Excel)</span>
			</el-button>
			<div style="padding: 10px; display: flex;justify-content: flex-end;">
				<el-pagination @current-change="handleCurrent" :current-page.sync="currentPage2" :page-size="page.per_page"
					layout="prev, pager, next, jumper" :total="page.total" background>
				</el-pagination>
			</div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { tableRouterView, tableSortHandle } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableSortHandle, tableRouterView ],
    data() {
        return {
			monthArray:'',
            // 开始日期
            startDate:"",
            // 结束日期
            endDate:"",
            // 日期选项的快捷选项绑定数据
            pickerOptions: {
                disabledDate:(time)=>{
                    return time.getTime() < this.startDate;
                }
            },
        }
    },

    computed: mapState({
		power: state => state.user.power,
        character_id: state => state.user.character_id,
        statement: state => state.user.statement,
        page: state => state.user.page,
		
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
    },
    methods: {
        ...mapMutations([
            "setStatement",
        ]),
        ...mapActions([
            "getStatement",
        ]),
        getData(attr, mode, page = 1) {
            this.getStatement({
                release: this.startDate,
                relend: this.endDate,
                attr,
                mode,
                page
            })
        },
		// 下載(PDF)
		submitCart(){
			window.location.href = this.$URL.baseUrl+'index/tcpdf/month?lang=cn&month='+ this.monthArray
			console.log(this.$URL.baseUrl+'index/tcpdf/month?lang=cn&month='+ this.monthArray)
			// if(this.monthArray.length == 0){
			// 	this.$message({
			// 	    showClose: true,
			// 	    message: "請選擇月份",
			// 	    type: "warning"
			// 	})
			// }else{
			// 	window.location.href = this.$URL.baseUrl+'index/tcpdf/month?lang=cn&month='+ this.monthArray	
			// }
			
			
		},
		// 下載(Excel)
		submitCartr(){
			window.location.href = this.$URL.baseUrl+'index/month/excel?lang=cn&month='+ this.monthArray	
			console.log(this.$URL.baseUrl+'index/month/excel?lang=cn&month='+ this.monthArray)
			// if(this.monthArray.length == 0){
			// 	this.$message({
			// 	    showClose: true,
			// 	    message: "請選擇月份",
			// 	    type: "warning"
			// 	})
			// }else{
			// 	window.location.href = this.$URL.baseUrl+'index/month/excel?lang=cn&month='+ this.monthArray	
			// }
			
		},
		// 多选事件
		handleSelect(val){ 
		    let new_val = [];
		    for(let item of val){
		        new_val.push(item.month)
		    }
			this.monthArray = new_val.join(',');    
		},
        changeRouter(search, attr, mode, page = 1) {
            this.$router.push({
                name: 'statement',
                query: {
                    attr,
                    mode,
                    page
                }
            }).catch(err => err)
        },
        // 起始日期改变时
        startChange(){
            if(this.endDate<this.startDate){
                this.endDate=""
            }
        },
        // 查询按钮
        handleSearch(){
            this.getStatement({
                release: this.startDate,
                relend: this.endDate
            })
        }
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
            // let allow = vm.character_id!=3 && vm.character_id!=4 && vm.character_id!=6,
            //     {
            //         attr = '',
            //         mode = '',
            //         page = 1
            //     } = to.query;
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(15)
				if(!allow){
				    vm.$router.back();
				    return false;
				}else{
					let  attr = '';
					let  mode = '';
					let  page = 1;
					vm.getData(attr, mode, page);
				}
			}, 500)
            
        })
    },
    beforeRouteUpdate(to, from, next) {
        let {
            attr = '',
            mode = '',
            page = 1
        } = to.query;
        
        this.getData(attr, mode, page);
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.setStatement([]);
        next();
    }
}
</script>

<style scoped>
/* 内容区域 */
.center_statement_content{
    padding: 30px 20px;
    background: #fff;
}
/* 日期选择区域 */
.center_statement_date{
    padding-left: 50px;
}
/* 按钮 */
.shopping_cart_table_btn{
    width: 115px;
    height: 50px;
}
/* 搜索按钮 */
.center_statement_search{
    margin-left: 10px;
}
</style>
